module.exports = __webpack_public_path__ + "static/media/eye.c334619b.svg";